import { useState } from 'react';

import {
  S9ComponentConfig,
  S9ComponentConfigCategory,
  S9ComponentConfigRelease,
} from '@april9au/stack9-sdk';
import * as ui from '@april9au/stack9-ui';

import { AppRoutes } from '../../constants/appRoutes';
import { entityNames } from '../../constants/entities';
import { EDetailsQueryNames } from '../../constants/queryNames';
import { DBSurveyQuestion } from '../../models/stack9/SurveyQuestion';
import { EntityDrawer } from '../EntityDrawer/EntityDrawer';

const S9Button = ui.S9Button.default;
const { useRefreshList, Space } = ui;

export const config: S9ComponentConfig = {
  name: 'SurveyQuestionDrawerAction',
  icon: '',
  category: S9ComponentConfigCategory.GENERAL,
  version: S9ComponentConfigRelease.ALPHA,
  hasState: true,
  allowChildren: false,
  props: [],
};

type SurveyQuestionDrawerActionProps = {
  row: Partial<DBSurveyQuestion>;
};

const SurveyQuestionDrawerAction = ({
  row,
}: SurveyQuestionDrawerActionProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const refresh = useRefreshList();
  const formFields = [
    { field: 'code', colSize: 12, isRequired: false },
    { field: 'sequence', colSize: 12 },
    { field: 'question' },
    { field: 'lang_set' },
    { field: 'is_active' },
  ];
  return (
    <>
      {row.id ? (
        <S9Button
          type="link"
          style={{ width: '100%', textAlign: 'left' }}
          onClick={() => setIsOpen(true)}
          label={`${row.code}`}
        />
      ) : (
        <Space>
          <S9Button
            label="Create"
            onClick={() => setIsOpen(true)}
            type="primary"
          />
        </Space>
      )}
      <EntityDrawer
        title="survey question"
        id={row?.id}
        open={isOpen}
        formFields={formFields}
        initialValues={row}
        onClose={() => {
          setIsOpen(false);
          refresh();
        }}
        screenQueryName={EDetailsQueryNames.GetSurveyQuestionDetails}
        entityName={entityNames.SURVEY_QUESTION}
        editRoute={AppRoutes.CountryTemplateDetail}
        relativePath={AppRoutes.CountryTemplateDetail}
      />
    </>
  );
};

export default SurveyQuestionDrawerAction;
